module.exports = __webpack_public_path__ + "img/Image.4f2041a3.svg";